import { Card, Grid, Icon, IconButton, MenuItem, Switch } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import { useState, useEffect } from "react";
import { post } from "utils/WebService";
import { ESCURO } from "assets/coresTema";

export default function MarcacaoEspecialCreateEdit({ id, closeCreateEdit, dataOriginal }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    
    const [formData, setFormData] = useState({
        ccNome: "",
        cvAlvo: 3,
        cvAtivo: true
    });
    
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (id && dataOriginal) {
            setFormData({
                ccNome: dataOriginal.ccNome,
                cvAlvo: dataOriginal.cvAlvo,
                cvAtivo: dataOriginal.cvAtivo
            });
        }
    }, [id, dataOriginal]);

    const handleSave = () => {
        if (!formData.ccNome) {
            alert("Nome é obrigatório");
            return;
        }
        setLoading(true);
        const req = id ? post(`/marcacoes/${id}`, formData) : post("/marcacoes", formData);
        
        req.then(() => {
            setLoading(false);
            closeCreateEdit();
        }).catch(() => {
            setLoading(false);
            alert("Erro ao salvar marcação");
        });
    };

    return (
        <Card id="marcacao-info" sx={{ background: darkMode ? ESCURO.cartao : "#ffffff" }}>
            <MDBox display="flex" alignItems="center" p={3}>
                <IconButton onClick={closeCreateEdit} sx={{ p: 0, paddingRight: 1 }}>
                    <MDTypography variant="h5" color={darkMode ? "white" : "inherit"}>
                        <Icon>arrow_back</Icon>
                    </MDTypography>
                </IconButton>
                <MDTypography variant="h6" color={darkMode ? "white" : "inherit"}>
                    {id ? "Editar" : "Nova"} Marcação Especial
                </MDTypography>
            </MDBox>

            <MDBox px={3} pb={3}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <MDInput
                            fullWidth
                            variant="standard"
                            label="Nome da Marcação"
                            placeholder="Informe o nome..."
                            value={formData.ccNome}
                            onChange={(e) => setFormData({ ...formData, ccNome: e.target.value })}
                            required
                        />
                    </Grid>
                
                    <Grid item xs={12} sm={3}>
                        <MDInput
                            select
                            fullWidth
                            variant="standard"
                            label="Aplica-se a"
                            value={formData.cvAlvo}
                            onChange={(e) => setFormData({ ...formData, cvAlvo: e.target.value })}
                        >
                            <MenuItem value={1}>Ficha (Devedor)</MenuItem>
                            <MenuItem value={2}>Contrato</MenuItem>
                            <MenuItem value={3}>Ambos</MenuItem>
                        </MDInput>
                    </Grid>

                    <Grid item xs={12} sm={3} display="flex" alignItems="center" pt={3} pl={1}>
                        <MDTypography variant="button" fontWeight="regular" color={darkMode ? "white" : "text"}>Inativo</MDTypography>
                        <Switch 
                            checked={formData.cvAtivo} 
                            onChange={(e) => setFormData({ ...formData, cvAtivo: e.target.checked })} 
                        />
                        <MDTypography variant="button" fontWeight="regular" color={darkMode ? "white" : "text"}>Ativo</MDTypography>
                    </Grid>
                </Grid>

                <MDBox 
                    display="flex" 
                    justifyContent="flex-end" 
                    mt={4} 
                    pt={2}
                    sx={{ borderTop: darkMode ? "1px solid rgba(255, 255, 255, 0.12)" : "1px solid #e0e0e0" }}
                >
                    <MDButton 
                        variant="outlined" 
                        color="secondary" 
                        onClick={closeCreateEdit} 
                        sx={{ 
                            mr: 2, 
                            color: darkMode ? "#ffffff !important" : undefined, 
                            borderColor: darkMode ? "rgba(255, 255, 255, 0.4) !important" : undefined,
                            backgroundColor: darkMode ? "rgba(255, 255, 255, 0.05)" : undefined,
                            "&:hover": {
                                borderColor: darkMode ? "#ffffff !important" : undefined,
                                backgroundColor: darkMode ? "rgba(255, 255, 255, 0.1)" : undefined
                            }
                        }}
                    >
                        Cancelar
                    </MDButton>
                    <MDButton 
                        variant="contained" 
                        color="info" 
                        onClick={handleSave} 
                        disabled={loading}
                        sx={{
                            backgroundColor: darkMode ? "#007bff !important" : undefined,
                            color: "#ffffff !important",
                            fontWeight: "bold",
                            boxShadow: darkMode ? "0 4px 10px rgba(0, 123, 255, 0.3)" : undefined,
                            "&:hover": {
                                backgroundColor: darkMode ? "#0069d9 !important" : undefined
                            }
                        }}
                    >
                        Salvar
                    </MDButton>
                </MDBox>
            </MDBox>
        </Card>
    );
}
